export default {
  theme: {
    blue: '天空蓝',
    teal: '碧落青',
    rose: '玫瑰红',
    violet: '罗兰紫',
    orange: '霞光橙',
  },
  home: {
    started: "从这里开始",
    components: "组件库",
    tableOfContent: "目录",
    version: "版本",
    changelog: "更新日志",
    download: "下载",
  },
  toolbar: {
    plus: '添加',
    account: '账户',
    logout: '登出',
    setting: '设置',
    theme: '主题',
    language: '语言',
    date: '选择日期',
    create: '创建',
  },
  task: {
    task: '任务',
    name: '任务名称',
    addTask: '添加任务',
    editTask: '编辑任务',
    taskTitle: '任务标题',
    project: '项目',
    projectId: '项目ID',
    startDate: '起始日期',
    endDate: '结束日期',
    selectStartDate: '选择起始日期',
    selectEndDate: '选择结束日期',
    executor: '执行人',
    selectExecutor: '选择执行人',
    selectProject: '选择项目',
    sponsor: '发布人',
    save: '保存',
    cancel: '取消',
    start: '起始',
    end: '结束',
    pleaseEnterTaskTitle: '请输入任务标题',
    listView: '列表视图',
    cardView: '卡片视图',
  },
  project: {
    project: '项目',
    projectList: '项目列表',
    projectDetail: '项目详情',
    projectInfo: '项目信息',
    createProject: '创建项目',
    createFirstProject: '创建第一个项目',
    noProjects: '暂无项目',
    selectProject: '选择项目',
    name: '项目名称',
    nameRequired: '请输入项目名称',
    code: '项目代码',
    version: '版本',
    purpose: '项目目的',
    target: '项目目标',
    remark: '备注',
    createAt: '创建时间',
    taskList: '任务列表',
    projectNotFound: '项目不存在',
    createSuccess: '项目创建成功',
    createFailed: '项目创建失败',
    updateSuccess: '项目更新成功',
    updateFailed: '项目更新失败',
    deleteSuccess: '项目删除成功',
    deleteFailed: '项目删除失败',
    confirmDelete: '确定要删除该项目吗？',
    type: '项目类型',
    abbr: '简称',
    profile: '简介',
    order: '订单',
    train: '培训',
    sectum: '部门',
    section: '部门',
    assembly: '装配',
    source: '资源',
    machine: '机器',
    system: '系统',
    standard: '标准',
    industry: '行业',
    technology: '技术',
    total: '总计',
    involved: '参与',
    created: '创建',
    quantity: '数量',
    create: '创建',
    dashboard: '仪表盘',
    task: '任务',
    file: '文件',
    product: '产品',
    member: '成员',
    fileList: '文件列表',
    productList: '产品列表',
    memberList: '成员列表',
    listView: '列表视图',
    cardView: '卡片视图',
  },
  common: {
    save: '保存',
    cancel: '取消',
    confirm: '确认',
    delete: '删除',
    edit: '编辑',
    more: '更多',
    message: '消息',
    notice: '通知',
    contact: '联系',
    userLogin: '用户登录',
    userLogout: '用户登出',
    previous: '上一张',
    next: '下一张',
    goToSlide: '跳转到第 {index} 张',
    confirmDelete: '确定要删除该任务吗？',
    carouselImage: '轮播图 {index}',
    collapseCode: '折叠代码',
    expandCode: '展开代码',
    copyCode: '复制代码',
    totalTasks: '总任务',
    hide: '隐藏',
    show: '显示',
    completed: '已完成',
    total: '总计',
    quantity: '数量',
    pleaseSelect: '请选择',
    pleaseInput: '请输入',
    selectUser: '选择用户',
    back: '返回',
  },
  date: {
    previousYear: '上一年',
    nextYear: '下一年',
    previousMonth: '上一月',
    nextMonth: '下一月',
    sunday: '星期日',
    monday: '星期一',
    tuesday: '星期二',
    wednesday: '星期三',
    thursday: '星期四',
    friday: '星期五',
    saturday: '星期六',
    january: '一月',
    february: '二月',
    march: '三月',
    april: '四月',
    may: '五月',
    june: '六月',
    july: '七月',
    august: '八月',
    september: '九月',
    october: '十月',
    november: '十一月',
    december: '十二月',
    today: '今天',
    clear: '清除',
    now: '现在',
  },
  document: {
    document: '文档',
    title: '文档标题',
    content: '文档内容',
    author: '作者',
    category: '分类',
    tags: '标签',
    status: '状态',
    published: '已发布',
    draft: '草稿',
    archived: '已归档',
    views: '浏览量',
    likes: '点赞',
    comments: '评论',
    create: '写文档',
    edit: '编辑文档',
    delete: '删除文档',
    publish: '发布',
    unpublish: '下架',
    listView: '列表视图',
    cardView: '卡片视图',
  },
};
